<!-- version 2021/05/20 -->
<template>
<div class="d-inline-flex p_relative">
  <app-label-text class="mb-0" :title="title"></app-label-text>
  <app-normal-text class="mr-3" :text="text"></app-normal-text>
</div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String
  }
}
</script>

<style lang="sass" scoped>
label, span
  color: rgba(0,0,0,.6)
</style>
